import { apiCall, ApiConfig } from '../../config/api'
import { getTypesPriorityAction } from '../actions/typePriorityActions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { TypePriority } from '../../interfaces'
import { GET_TYPE_PRIORITY } from '../types/typePriorityActionsTypes'
import { ApiResponse } from '../../typings/ApiResponse'

export function* getTypesPriorityAsync() {
  try {
    const { status, data }: AxiosResponse<ApiResponse<TypePriority>> =
      yield call(apiCall, 'GET', `${ApiConfig.TypePriorityApi}`)
    if (status === 200) {
      yield put(getTypesPriorityAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypesPriorityAction([], serverError.message))
  }
}

export function* watchGetTypesPriorityAsync() {
  yield takeEvery(GET_TYPE_PRIORITY, getTypesPriorityAsync)
}
